import iterate from './iterate';



export const setHTML = (element, htmlString) =>
  iterate(element, (element) => {
    element.innerHTML = htmlString;
  });

export const setText = (element, string) =>
  iterate(element, (element) => {
    element.innerText = string;
  });


export const getValueString = (element) => {
  let val = '';

  iterate(element, (element, i) => {
    if (i !== 0) {
      return false;
    }

    val = String(element.value || '');

    return true;
  });

  return val;
};



// WEBPACK FOOTER //
// ./src/lib/dom/inner.js